export const markAsRead = "$Ra";
export default {markAsRead};